<template>
  <div class="p-4">
    <el-form :inline="true" size="mini">
      <el-form-item label="选择衣橱">
        <el-select
          @change="onWardrobeChange"
          filterable
          v-model="wardrobeId"
          placeholder="请选择衣橱"
        >
          <el-option
            v-for="item in wardrobeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <h5 style="color: #fff"><span></span>次元动作-衣橱</h5>
    <action-table
      :skin-id="wardrobeId"
      :action-type="61"
      :data-url="dataUrl"
      :data-more-url="dataMoreUrl"
      :type="$route?.query?.type"
      class="mt-3"
    />

    <el-form :inline="true" size="mini" class="pt-3 mt-5">
      <el-form-item label="选择农场">
        <el-select
          @change="onFarmChange"
          filterable
          v-model="farmId"
          placeholder="请选择农场"
        >
          <el-option
            v-for="item in farmOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <h5 style="color: #fff"><span></span>次元动作-农场</h5>
    <action-table
      :skin-id="farmId"
      :action-type="62"
      :data-url="dataUrl"
      :data-more-url="dataMoreUrl"
      :type="$route?.query?.type"
      class="mt-3"
    />
  </div>
</template>


<script>
import ActionTable from './action-table.vue'
import axios from 'axios'

export default {
  components: {
    ActionTable,
  },
  props: {
    project: {
      type: [String, Number],
      default: 57,
    },
    // 表格主数据请求地址
    dataUrl: {
      type: String,
      default: '/report/dimension_action_data/',
    },
    // 「查看更多」分页数据请求地址
    dataMoreUrl: {
      type: String,
      default: '/report/dimension_action_data_more/',
    },
  },

  data() {
    return {
      wardrobeId: '',
      wardrobeOptions: [],
      farmId: '',
      farmOptions: [],
    }
  },

  async mounted() {
    this.wardrobeOptions = await this.fetchActionSceneList(61)
    this.farmOptions = await this.fetchActionSceneList(62)
    if (this.wardrobeOptions.length) {
      this.wardrobeId = this.wardrobeOptions[0].value
    }
    if (this.farmOptions.length) {
      this.farmId = this.farmOptions[0].value
    }
  },

  methods: {
    async fetchActionSceneList(actionType) {
      const { data } = await axios.get('/proj/dimension_action_scene_list/', {
        params: {
          project: this.project,
          action_type: actionType,
        },
      })
      return data.map((item) => ({
        value: item.original_scene_id,
        label: item.chinese,
      }))
    },

    onWardrobeChange(val) {
      // 选择衣橱后的回调，可按需扩展
    },

    onFarmChange() {
      // 选择农场后的回调，可按需扩展
    },
  },
}
</script>

<style scoped>
.el-form-item :deep(.el-form-item__label) {
  color: #fff;
}
</style>
